import { SET_DICTIONARY } from './action-types';

export const setDictionary = (name, dictionary) => ({
  type: SET_DICTIONARY,
  payload: {
    name: name,
    dictionary: dictionary,
  },
});
